import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Row, Col, Alert, Container, CardBody, Card } from "reactstrap";
import { useLocation } from "react-router-dom";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import queryString from "query-string";
import { Capacitor } from "@capacitor/core";
// Redux
import logo from "../../assets/images/Logo.png";
import { connect } from "react-redux";
import Loader from "react-loader-spinner";
import { withRouter, Link } from "react-router-dom";
import logowhite from "../../assets/images/logowhite.png";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// import images
import logolight from "../../assets/images/logo-light.png";
import { TokenAppenditure, LoginToken } from "../Utility/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TbAlertCircleFilled } from "react-icons/tb";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";
import config from "../../config";

//Import config
const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const Login = (props) => {
  const [userID, setUserID] = useState();
  const [email, setEmail] = useState();
  const location = useLocation();
  let params = queryString.parse(location.search);
  const [isUploading, setIsUploading] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [form, setForm] = useState(1);
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleUserIDChange = (e) => {
    setUserID(e.target.value);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const [password, setPassword] = useState();
  const [pwInputType, setPwInputType] = useState("password");
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    // console.log(values)
  };
  const [error, setError] = useState("");

  useEffect(() => {
    if (params.reset_success) {
      setSuccessMessage(
        "Your password has been successfully reset. Please log in."
      );
    }
  }, [params.reset_success]);

  const onPasswordVisibleClick = (e) => {
    e.preventDefault();
    setPwInputType(pwInputType === "password" ? "text" : "password");
  };

  const loginAttempt = () => {
    setIsUploading(true);
    fetch(`${config.genni.marketing_portal.API_KEY}/creatorapi/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username: userID, password: password }),
    })
      .then(async (res) => {
        if (res.ok) {
          setIsUploading(false);
          return res.json();
        } else {
          await res.text().then((text) => {
            const errText = new Error(text);
            setError(
              JSON.parse(errText.message).messages[0] +
                ". Having trouble logging in? Contact outreach@genni.com"
            );
            setIsUploading(false);
          });
        }
        throw res;
        //const jsonRes = JSON.parse(res);
      })
      .then(async (data) => {
        if (data.error) {
          setError(
            `${data.messages[0]} Having trouble logging in? Contact outreach@genni.com`
          );
          setIsUploading(false);
        } else {
          await Cookies.set(
            "ContactDetail",
            JSON.stringify(data.contactDetail)
          );
          await Cookies.set("LoginToken", data.data.token);
          const redirectLink = Capacitor.isNativePlatform()
            ? `/dashboard?token=${data.data.token}`
            : "/dashboard";

          const params = new URLSearchParams(window.location.search);
          const returnTo = decodeURIComponent(params.get("returnTo") || "");

          if (returnTo) {
            window.location.href = returnTo;
          } else {
            window.location.href = redirectLink;
          }
        }
      });
  };

  const linkEmail = () => {
    fetch(
      `https://api.genni.com/username?username=${encodeURIComponent(
        email
      )}&x-api-key=${Cookies.get("LoginToken")}`,
      { method: "POST" }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw res;
        //const jsonRes = JSON.parse(res);
      })
      .then(async (data) => {
        // console.log("data", data);
        setForm(3);
      })
      .catch((error) => {
        setError("Duplicate or Invalid Credentials");
      });
  };

  useEffect(() => {
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    if (params.token || Cookies.get("LoginToken")) {
      fetch(`${config.genni.marketing_portal.API_KEY}/creatorapi/check`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": params.token || Cookies.get("LoginToken"),
        },
      })
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            await res.text().then((text) => {
              const errText = new Error(text);
              setError(JSON.parse(errText.message).messages[0]);
            });
          }
          throw res;
          //const jsonRes = JSON.parse(res);
        })
        .then(async (data) => {
          // console.log("data",data);
          if (data.results.success) {
            if (params.token) {
              await Cookies.set("LoginToken", params.token);
              await Cookies.set(
                "ContactDetail",
                JSON.stringify(data.results.contactDetail)
              );
              window.location.href = `/dashboard`;
            } else {
              window.location.href = `/dashboard`;
            }
          }
        });
    }
    return function cleanup() {
      document.body.className = "";
    };
  });

  const returnForm = () => {
    if (form === 1) {
      return (
        <>
          <div className="text-center mt-2">
            {error && <Alert color="danger">{error}</Alert>}
            {params.confirmation && !error && (
              <Alert color="success">
                You have successfully confirmed your email!
              </Alert>
            )}
            {/* <Alert color="warning">We are currently experiencing some technicaly difficulties. We apologize for the inconvenience. Please check back soon!</Alert> */}

            <div className="border p-1 rounded mb-4" style={{width:'100%', display:'flex',flexDirection:'none'}}>
              <a className="full-width" style={{color: '#08090a !important'}} href="#">
                <button style={{letterSpacing:'-0.01em', fontWeight:500,color:'#08090a' }} className="full-width bg-light border-none  h-9 px-3 py-2 text-sm rounded">
                  Creators
                </button>
              </a>
              <a className="full-width" style={{color:'#08090a !important'}} href='https://portal.genni.com'>
              <button style={{letterSpacing:'-0.04em', fontWeight:500, color: '#08090a'}} className="full-width bg-white border-none  h-9 px-3 py-2 text-sm rounded">
                Marketers
              </button>
              </a>
            </div>
            <p className="text-muted mt-3 mb-0">Sign in to continue to genni.</p>


          </div>
          <div className="p-2 mt-0">
            <AvForm
              className="form-horizontal"
              onValidSubmit={(e, v) => {
                handleValidSubmit(e, v);
              }}
            >
              {props.error && typeof props.error === "string" ? (
                <Alert color="danger">{props.error}</Alert>
              ) : null}

              <div className="mb-3">
                <AvField
                  name="userID"
                  label="Email"
                  value={userID}
                  onChange={handleUserIDChange}
                  validate={{
                    required: { value: true },
                  }}
                  className="form-control inputField"
                  placeholder="Enter Email"
                  type="text"
                  required
                />
              </div>

              <div className="mb-3">
                <div className="float-end">
                  <Link to="/forgot-password" className="text-muted" style={{fontSize:14}}>
                    Forgot password?
                  </Link>
                </div>
                <AvField
                  name="password"
                  type={pwInputType}
                  placeholder="Enter Password"
                  className="form-control inputField"
                  label="Password"
                  errorMessage="Invalid Password"
                  value={password}
                  onChange={handlePasswordChange}
                  validate={{
                    required: { value: true },
                  }}
                />
              </div>

              <div
                className="form-check"
                style={{
                  paddingTop: "0px",
                }}
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="customControlInline"
                />
                <label
                  className="form-check-label"
                  htmlFor="customControlInline"
                  style={{ fontSize: 14 }}
                >
                  Remember me
                </label>
              </div>

              <div className="mt-3">
                <button
                  className="btn gradient-pink btn-pink text-white w-100 waves-effect waves-light"
                  onClick={loginAttempt}
                >
                  {isUploading ? (
                    <Loader type="Bars" color="#fff" height={20} width={40} />
                  ) : (
                    "Log In"
                  )}
                </button>
              </div>
            </AvForm>
            <div className="mt-4 text-center">
              <p className="mb-0 text-muted">
                Don't have an account?{" "}
                <a href="/hello" className="fw-medium text-pink">
                  {" "}
                  Sign Up{" "}
                </a>{" "}
              </p>
            </div>
          </div>
        </>
      );
    } else if (form === 2) {
      return (
        <>
          <div className="text-center mt-2">
            <h5 className="text-pink madeGentle">
              Link A Unique Email To Your Account
            </h5>
            <p className="text-muted">
              This email will be used to help you login going forward.
            </p>
          </div>
          <div className="p-2 mt-4">
            <AvForm
              className="form-horizontal"
              onValidSubmit={(e, v) => {
                handleValidSubmit(e, v);
              }}
            >
              {props.error && typeof props.error === "string" ? (
                <Alert color="danger">{props.error}</Alert>
              ) : null}

              <div className="mb-3">
                <AvField
                  name="email"
                  label="Email"
                  value={email}
                  onChange={handleEmailChange}
                  validate={{
                    required: { value: true },
                  }}
                  className="form-control"
                  placeholder="Enter Email"
                  type="text"
                  required
                />
              </div>

              <div className="mt-3">
                <p className="text-danger">{error}</p>
                <button
                  className={`btn gradient-navy text-white w-100 waves-effect waves-light ${
                    !validateEmail(email) && "disabled"
                  }`}
                  onClick={() => {
                    if (validateEmail(email)) {
                      linkEmail();
                    }
                  }}
                >
                  Submit
                </button>
              </div>

              {/* <div className="mt-4 text-center">
                        <p className="mb-0">
                          Don't have an account ?{" "}
                          <a
                            href="/register"
                            className="fw-medium text-pink"
                          >
                            {" "}
                            Signup now{" "}
                          </a>{" "}
                        </p>
                      </div> */}
            </AvForm>
          </div>
        </>
      );
    } else if (form === 3) {
      return (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "-30px",
            }}
          >
            <i
              className="mdi mdi-check-decagram"
              style={{ fontSize: 70, color: "#08090a" }}
            />
            Thank you for registering! We've sent an email to verify your
            account.
          </div>
        </>
      );
    }
  };

  return (
    <div className="login-grid">
      {/* Left Colored Section (Hidden on Mobile) */}
      <div
        className="hide-mobile"
        style={{
          backgroundColor: "#000",
          color: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "2rem",
          position: "relative",
        }}
      >
        {/* Logo in the Top Left */}
        <div style={{ position: "absolute", top: "1.5rem", left: "1.5rem" }}>
          <img
            src="https://portal.genni.com/img/logo/logo-dark-full.png"
            alt="Logo"
            style={{ height: "40px" }}
          />
        </div>

        <div style={{ marginTop: "auto", marginBottom: "auto" }}>
          <div
            style={{
              marginBottom: "1.5rem",
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "48px", // Adjust size as needed
                height: "48px",
                borderRadius: "50%",
                overflow: "hidden",
                border: "2px solid white",
              }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Bob-Marley_3_%28cropped%29.jpg/220px-Bob-Marley_3_%28cropped%29.jpg"
                loading="lazy"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </span>
            <div style={{ color: "white" }}>
              <div style={{ fontWeight: "600", fontSize: "1rem" }}>
                Bob Marley
              </div>
            </div>
          </div>
          <p style={{ fontSize: "1.125rem", color: "white", opacity: "0.8" }}>
            One good thing about music, when it hits you, you feel no pain.
          </p>
        </div>
        {/* Privacy & Terms Links */}
        <div style={{ textAlign: "center", fontSize: "14px" }}>
          <a
            href="/privacy"
            style={{
              color: "white",
              textDecoration: "none",
              marginRight: "10px",
            }}
          >
            Privacy Policy
          </a>
          |
          <a
            href="/terms"
            style={{
              color: "white",
              textDecoration: "none",
              marginLeft: "10px",
            }}
          >
            Terms of Service
          </a>
        </div>
      </div>

      {/* Right Login Form Section */}
      <div className="container pt-3 pb-3 border-bottom hide-desktop">
        <img
          src={logo}
          style={{ width: 100, height: "auto" }}
          className=""
          alt="genni"
        />
      </div>
      <div className="login-container">
        <Container>
          <Card className="login-card">
            <CardBody className="p-4">
              {successMessage && (
                <Alert color="success">{successMessage}</Alert>
              )}
              {returnForm()}
            </CardBody>
          </Card>
        </Container>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 768px) {
            div[style*="grid-template-columns"] {
              grid-template-columns: 1fr; /* Full width on mobile */
            }
            div[style*="background-color: #000"] {
              display: none; /* Hide left section on mobile */
            }
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(Login);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
};
